import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Logger.js";
import { EventMatch as t } from "./EventMatch.js";
var n = e.getLogger("esri.views.input.InputHandler");

var i = /*#__PURE__*/function () {
  function i(e) {
    _classCallCheck(this, i);

    this._manager = null, this._incoming = {}, this._outgoing = {}, this._incomingEventMatches = null, this._incomingEventTypes = null, this._outgoingEventTypes = null, this._hasSideEffects = e;
  }

  _createClass(i, [{
    key: "incomingEventMatches",
    get: function get() {
      if (!this._incomingEventMatches) {
        this._incomingEventMatches = [];

        for (var _e in this._incoming) {
          var _t = this._incoming[_e];

          var _iterator = _createForOfIteratorHelper(_t),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _e2 = _step.value;

              this._incomingEventMatches.push(_e2.match);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      return this._incomingEventMatches;
    }
  }, {
    key: "incomingEventTypes",
    get: function get() {
      return this._incomingEventTypes || (this._incomingEventTypes = this.incomingEventMatches.map(function (e) {
        return e.eventType;
      })), this._incomingEventTypes;
    }
  }, {
    key: "outgoingEventTypes",
    get: function get() {
      return this._outgoingEventTypes || (this._outgoingEventTypes = Object.keys(this._outgoing)), this._outgoingEventTypes;
    }
  }, {
    key: "hasSideEffects",
    get: function get() {
      return this._hasSideEffects;
    }
  }, {
    key: "hasPendingInputs",
    get: function get() {
      return !1;
    }
  }, {
    key: "onInstall",
    value: function onInstall(e) {
      var _this = this;

      this._manager ? n.error("This InputHandler has already been registered with an InputManager") : (e.setEventCallback(function (e) {
        return _this._handleEvent(e);
      }), e.setUninstallCallback(function () {
        return _this._onUninstall();
      }), this._manager = e);
    }
  }, {
    key: "onUninstall",
    value: function onUninstall() {}
  }, {
    key: "registerIncoming",
    value: function registerIncoming(e, n, _i) {
      var _this2 = this;

      var a;
      "function" == typeof n ? (_i = n, a = []) : a = n || [];

      var o = "string" == typeof e ? new t(e, a) : e,
          h = function h() {
        _this2._incomingEventTypes = null, _this2._incomingEventMatches = null;
      },
          r = function r(e) {
        var t = _this2._incoming[e.match.eventType];

        if (t) {
          var _n = t.indexOf(e);

          t.splice(_n, 1), h(), _this2._manager && _this2._manager.updateDependencies();
        }
      },
          g = new s(o, _i, {
        onPause: r,
        onRemove: r,
        onResume: function onResume(e) {
          var t = _this2._incoming[e.match.eventType];
          t && -1 === t.indexOf(e) && (t.push(e), h(), _this2._manager && _this2._manager.updateDependencies());
        }
      });

      var c = this._incoming[o.eventType];
      return c || (c = [], this._incoming[o.eventType] = c), c.push(g), h(), this._manager && this._manager.updateDependencies(), g;
    }
  }, {
    key: "registerOutgoing",
    value: function registerOutgoing(e) {
      var _this3 = this;

      if (this._outgoing[e]) throw Error("There is already a callback registered for this outgoing InputEvent: " + e);
      var t = new a(e, {
        onEmit: function onEmit(e, t, n, _i2) {
          _this3._manager.emit(e.eventType, t, n, _i2);
        },
        onRemove: function onRemove(e) {
          delete _this3._outgoing[e.eventType], _this3._manager.updateDependencies();
        }
      });
      return this._outgoing[e] = t, this._outgoingEventTypes = null, this._manager && this._manager.updateDependencies(), t;
    }
  }, {
    key: "startCapturingPointer",
    value: function startCapturingPointer(e) {
      this._manager.setPointerCapture(e, !0);
    }
  }, {
    key: "stopCapturingPointer",
    value: function stopCapturingPointer(e) {
      this._manager.setPointerCapture(e, !1);
    }
  }, {
    key: "refreshHasPendingInputs",
    value: function refreshHasPendingInputs() {
      this._manager.refreshHasPendingInputs();
    }
  }, {
    key: "_onUninstall",
    value: function _onUninstall() {
      this._manager ? (this.onUninstall(), this._manager = null) : n.error("This InputHandler is not registered with an InputManager");
    }
  }, {
    key: "_handleEvent",
    value: function _handleEvent(e) {
      var t = this._incoming[e.type];

      if (t) {
        var _iterator2 = _createForOfIteratorHelper(t),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _n2 = _step2.value;
            if (_n2.match.matches(e) && (_n2.callback(e), e.shouldStopPropagation())) break;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }]);

  return i;
}();

var s = /*#__PURE__*/function () {
  function s(e, t, n) {
    _classCallCheck(this, s);

    this.match = e, this._callback = t, this._handler = n;
  }

  _createClass(s, [{
    key: "pause",
    value: function pause() {
      this._handler.onPause(this);
    }
  }, {
    key: "resume",
    value: function resume() {
      this._handler.onResume(this);
    }
  }, {
    key: "remove",
    value: function remove() {
      this._handler.onRemove(this);
    }
  }, {
    key: "callback",
    get: function get() {
      return this._callback;
    }
  }]);

  return s;
}();

var a = /*#__PURE__*/function () {
  function a(e, t) {
    _classCallCheck(this, a);

    this.eventType = e, this._removed = !1, this._handler = t;
  }

  _createClass(a, [{
    key: "emit",
    value: function emit(e, t, n) {
      this._removed || this._handler.onEmit(this, e, t, n);
    }
  }, {
    key: "remove",
    value: function remove() {
      this._removed = !0, this._handler.onRemove(this);
    }
  }]);

  return a;
}();

export { i as InputHandler };